export default {
  en: {
    translation: require("./locales/en_US"),
  },
  ko: {
    translation: require("./locales/ko_KR"),
  },
};
